import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ToastProvider } from './components/common/Toast';
import { CurrencyProvider } from './utils/currency';
import { ComparateurProvider } from './components/common/Comparateur';
import { I18nProvider } from './i18n/I18nContext';
import App from './App';
import './styles/variables.css';
import './styles/animations.css';
import './styles/glassmorphism.css';
import './index.css';

// ── Forcer le thème clair (dark mode supprimé) ──
localStorage.removeItem('darna-immo_theme');
document.documentElement.removeAttribute('data-theme');

// ── Service Worker (PWA) — production uniquement ──
if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js')
      .then(reg => {
        // Vérifier les mises à jour toutes les 60s
        setInterval(() => reg.update(), 60_000);
      })
      .catch(() => {});
  });
} else if ('serviceWorker' in navigator) {
  // En développement : désinscrire tout SW existant pour éviter les boucles HMR
  navigator.serviceWorker.getRegistrations().then(regs => {
    regs.forEach(reg => reg.unregister());
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <I18nProvider>
        <AuthProvider>
          <CurrencyProvider>
            <ComparateurProvider>
              <ToastProvider>
                <App />
              </ToastProvider>
            </ComparateurProvider>
          </CurrencyProvider>
        </AuthProvider>
    </I18nProvider>
  </BrowserRouter>
);
